import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "./dialog";
import { Progress } from "./progress";
import { Loader2 } from "lucide-react";

export function DownloadProgressDialog({ open, progress, onOpenChange }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Generating CSV</DialogTitle>
                    <DialogDescription>
                        Please wait while your CSV file is being generated. This may take a moment for large datasets.
                    </DialogDescription>
                </DialogHeader>
                <div className="py-6">
                    <Progress value={progress} className="h-2 mb-2" />
                    <p className="text-sm text-center text-gray-500">{progress}% complete</p>
                    <div className="flex justify-center mt-4">
                        <Loader2 className="h-6 w-6 animate-spin text-gray-500" />
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
} 